import { type ComponentProps } from "solid-js"
import mark from "../assets/brand/sair-mark.svg"
import { wordmark } from "../assets/brand/wordmark"

export { wordmark }

export const Mark = (props: { class?: string }) => {
  return (
    <svg
      data-component="logo-mark"
      class={props.class}
      viewBox="0 0 1039 1039"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <image href={mark} width="1039" height="1039" />
    </svg>
  )
}

export const Splash = (props: Pick<ComponentProps<"svg">, "ref" | "class">) => {
  return (
    <svg
      ref={props.ref}
      data-component="logo-splash"
      class={props.class}
      viewBox="0 0 1039 1039"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <image href={mark} width="1039" height="1039" />
    </svg>
  )
}

export const Logo = (props: { class?: string }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 276 94"
      fill="currentColor"
      class={props.class}
      aria-hidden="true"
    >
      <path d={wordmark} />
    </svg>
  )
}
